import React from 'react'
import { observer, inject } from 'mobx-react'

import { BoxCenter } from '../../../generic/Box'
import Title from '../../../generic/Title'
import Loader from '../../../generic/Loader'
import TileShowcase from '../../TileShowcase'

const ReinfAmountSent = inject('reinfStore')(observer(props => {
  const { reinfStore } = props
  const { isFetching } = reinfStore.state
  return (
    <BoxCenter>
      <Title>Arquivos Enviados</Title>
      <Loader isLoading={isFetching}>
        <TileShowcase data={reinfStore.amountSent} />
      </Loader>
    </BoxCenter>
  )
}))

export default ReinfAmountSent



// WEBPACK FOOTER //
// ./src/components/dashboard/products/4reinf/ReinfAmountSent.js